import { type Trello } from "../types/trello"
import { apiClient } from "../api/api"
import { getImportModal } from "../config"

export async function getOnEnable(t: Trello.PowerUp.IFrame): Promise<void> {
  // The top of the funnel. Sent unauthenticated because that is what someone
  // enabling a power-up is — the whole question is how many of them go on to
  // connect it. Never awaited: analytics must not delay the modal.
  apiClient
    .createAnalyticsEvent(
      t,
      "powerup_enabled",
      { memberId: t.getContext().member, boardId: t.getContext().board },
      { anonymous: true }
    )
    .catch(() => {})

  return t.modal(getImportModal())
}
